import { api } from '@/services/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { GET_ASSET_QUERY_KEY } from './useGetAsset';
import { GET_SUPPLEMENTAL_ASSETS_QUERY_KEY } from './useGetSupplementalAssets';
import { GET_CRITICAL_GEOMETRY_ARTIFACTS_QUERY_KEY } from './useGetCriticalGeometryArtifacts';

export const useUnlinkCriticalGeometryArtifact = () => {
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  const { mutate, isPending } = useMutation({
    mutationFn: ({ tenantId, assetId, artifactId }: { tenantId: string; assetId: string; artifactId: string }) =>
      api.assets.unlinkCriticalGeometryArtifact(tenantId, assetId, artifactId),
    onSuccess: (_data, { assetId }) => {
      queryClient.resetQueries({ queryKey: [GET_ASSET_QUERY_KEY, { assetId }] });
      queryClient.resetQueries({ queryKey: [GET_SUPPLEMENTAL_ASSETS_QUERY_KEY], exact: false });
      queryClient.invalidateQueries({ queryKey: [GET_CRITICAL_GEOMETRY_ARTIFACTS_QUERY_KEY], exact: false });
      showToast({ message: 'Supplemental asset removed successfully', type: 'success' });
    },
    onError: () => {
      showToast({ message: 'Failed to remove supplemental asset', type: 'error' });
    },
  });

  return {
    unlinkCriticalGeometryArtifact: mutate,
    isUnlinking: isPending,
  };
};
